/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Filters = ({
  selected,
  setSelected,
  searchTerm,
  setSearchTerm,
  country,
  setCountry,
}) => {
  const categories = ['tous', 'hotel', 'tour', 'sejour'];
  const [counts, setCounts] = useState({ tous: 0, hotel: 0, tour: 0, sejour: 0 });
  const [countries, setCountries] = useState([]);
  const capFirst = (s = '') =>
    s[0]?.toLocaleUpperCase('fr-FR') + s.slice(1).toLocaleLowerCase('fr-FR');

  // pays (avec dates futures)
  useEffect(() => {
    axios
      .get(`/api/products/countries`)
      .then((res) => setCountries(res.data))
      .catch((err) => console.error('Erreur chargement pays', err));
  }, []);

  // compteurs dynamiques selon les filtres de recherche (nom/pays)
  useEffect(() => {
    const source = axios.CancelToken.source();
    axios
      .get(`/api/products/typesCount`, {
        params: { searchTerm, country },
        cancelToken: source.token,
      })
      .then((res) => setCounts(res.data))
      .catch((err) => {
        if (!axios.isCancel(err)) console.error('Erreur counts', err);
      });

    return () => source.cancel();
  }, [searchTerm, country]);

  return (
    <div className="row mb-4" style={{ marginTop: '8rem', alignItems: 'center' }}>
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Rechercher par nom ou pays..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {categories.map((cat) => (
        <button
          key={cat}
          className={`btn btn-${selected === cat ? 'primary' : 'outline-primary'} mx-1`}
          onClick={() => setSelected(cat)}
        >
          {cat.charAt(0).toUpperCase() + cat.slice(1)} ({counts[cat] || 0})
        </button>
      ))}

      <div className="col">
        <select
          className="form-control"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        >
          <option value="">Tous les pays</option>
          {countries.map((c, idx) => (
            <option key={idx} value={c}>
              {capFirst(String(c))}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Filters;
